import { render, staticRenderFns } from "./DeductionAuth.vue?vue&type=template&id=47661a9a&scoped=true"
import script from "./DeductionAuth.vue?vue&type=script&lang=js"
export * from "./DeductionAuth.vue?vue&type=script&lang=js"
import style0 from "./DeductionAuth.vue?vue&type=style&index=0&id=47661a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47661a9a",
  null
  
)

export default component.exports